import { render, staticRenderFns } from "./TabsPanel.vue?vue&type=template&id=347c4f48&scoped=true"
import script from "./TabsPanel.vue?vue&type=script&lang=js"
export * from "./TabsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c4f48",
  null
  
)

export default component.exports